const resolvers = {}

export { resolvers }
